var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_28711)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33325C4.285 3.33325 1.57142 8.23212 0.913082 9.63045C0.803082 9.86379 0.803082 10.1344 0.913082 10.3678C1.57142 11.7669 4.285 16.6666 10 16.6666C15.695 16.6666 18.4104 11.8024 19.0804 10.384C19.1954 10.1399 19.1954 9.85997 19.0804 9.6158C18.4104 8.19747 15.695 3.33325 10 3.33325ZM10 5.83325C12.3008 5.83325 14.1667 7.69909 14.1667 9.99992C14.1667 12.3008 12.3008 14.1666 10 14.1666C7.69916 14.1666 5.83333 12.3008 5.83333 9.99992C5.83333 7.69909 7.69916 5.83325 10 5.83325ZM10 7.49992C9.33695 7.49992 8.70107 7.76331 8.23223 8.23215C7.76339 8.70099 7.5 9.33688 7.5 9.99992C7.5 10.663 7.76339 11.2988 8.23223 11.7677C8.70107 12.2365 9.33695 12.4999 10 12.4999C10.663 12.4999 11.2989 12.2365 11.7678 11.7677C12.2366 11.2988 12.5 10.663 12.5 9.99992C12.5 9.33688 12.2366 8.70099 11.7678 8.23215C11.2989 7.76331 10.663 7.49992 10 7.49992Z",
    fill: "#6C6C6C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_28711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide-password.e0e1298077c022c5553cb6b71410d640.svg";
export { ForwardRef as ReactComponent };